import grey from '@material-ui/core/colors/grey';
import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;
export type UserContentStylesProps = {
	spacing: number;
	zoomEnabled: boolean;
	isMobile: boolean;
};

export const useStyles = makeStyles(theme => {
	return {
		showroomContentContainer: {
			display: 'flex',
			flexDirection: 'column',
			paddingTop: 100,
			minHeight: 'calc(100% - 100px)'
		},
		showroomContentContainerMobile: {
			paddingTop: 50
		},
		showroomContentDownloadableMobile: {
			paddingBottom: 50
		},
		showroomHero: {
			width: '100%',
			position: 'relative',
			zIndex: 0,
			marginBottom: 20
		},
		showroomHeroMobile: {
			marginTop: 20,
			marginBottom: 20
		},
		showroomHeroMobileMedia: {
			marginTop: 0
		},
		showroomHeroBackground: {
			width: '100%',
			height: 753,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			boxSizing: 'border-box'
		},
		showroomHeroBackgroundMobile: {
			height: 'calc(100vh - 50px) !important'
		},
		showroomHeroBackgroundVideo: {
			width: '100%',
			height: 753
		},
		showroomHeroContainer: {
			position: 'relative',
			left: 144,
			marginTop: -264,
			backgroundColor: '#FFF',
			padding: '60px 70px',
			width: 676,
			'& p': {
				fontSize: '14px',
				lineHeight: '22px'
			}
		},
		showroomHeroContainerNoMedia: {
			marginTop: '0 !important'
		},
		showroomHeroContainerMobile: {
			left: 'auto',
			maxWidth: '90%',
			marginLeft: 'auto',
			marginRight: 'auto',
			boxSizing: 'border-box',
			padding: '40px 50px',
			marginTop: 'calc(-1 * 20vh)'
		},
		showroomHeroContainerCollapse: {},
		showroomHeroTitle: {
			fontSize: '36px',
			marginBottom: '30px',
			marginTop: 0,
			fontWeight: 'normal'
		},
		showroomHeroContent: {
			wordBreak: 'break-word'
		},
		showroomTitle: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			textTransform: 'uppercase',
			margin: '20px 0',
			'& h4': {
				fontSize: 18,
				fontWeight: 600,
				lineHeight: '21px',
				marginBottom: 5
			},
			'& h5': {
				fontSize: 16,
				fontWeight: 500,
				lineHeight: '19px'
			}
		},
		showroomTitleMobile: {
			padding: '20px 0px',
			position: 'absolute',
			transform: 'translateY(113%)'
		},
		showroomTitleMediaMobile: {
			padding: '0',
			zIndex: 10,
			width: '100%',
			'& h4, h5': {
				color: 'white'
			}
		},
		sectionTabsContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		},
		sectionTabsBox: {
			display: 'flex',
			alignItems: 'center',
			marginTop: ({ isMobile }: UserContentStylesProps) => (isMobile ? 15 : 30),
			marginBottom: 15,
			paddingBottom: ({ isMobile }: UserContentStylesProps) => (isMobile ? 15 : 30),
			overflowX: 'auto'
		},
		sectionTabBox: {
			display: 'flex',
			alignItems: 'center',
			whiteSpace: 'pre'
		},
		tab: {
			marginRight: 40,
			marginLeft: 40,
			fontSize: 18,
			color: grey[400]
		},
		tabLabel: {
			textTransform: 'uppercase'
		},
		tabSelected: {
			color: '#000',
			fontWeight: 'bold'
		},
		showroomGridContainer: {
			marginBottom: 50
		},
		showroomGrid: {
			maxWidth: '100%',
			margin: '3.33% 3.5% 3.33% 3.5%'
		},
		edgeToEdge: {
			marginLeft: 0,
			marginRight: 0
		},
		showroomGridContainerMobile: {
			marginTop: 10
		},
		showroomGridRow: {
			display: 'flex',
			flexWrap: 'wrap',
			'&:first-child': {
				paddingTop: 0
			},
			'&:last-child': {
				paddingBottom: 0
			},
			[theme.breakpoints.up('sm')]: {
				flexWrap: 'nowrap',
				paddingTop: (props: UserContentStylesProps) => `${props.spacing}%`,
				paddingBottom: (props: UserContentStylesProps) => `${props.spacing}%`
			}
		},
		showroomGridItem: {
			display: 'flex',
			flexDirection: 'column',
			paddingBottom: (props: UserContentStylesProps) => `${props.spacing}%`,
			paddingTop: (props: UserContentStylesProps) => `${props.spacing}%`,

			[theme.breakpoints.up('sm')]: {
				paddingLeft: (props: UserContentStylesProps) => `${props.spacing}%`,
				paddingRight: (props: UserContentStylesProps) => `${props.spacing}%`,
				paddingBottom: '0 !important',
				paddingTop: '0 !important',
				'&:first-child': {
					paddingLeft: 0
				},

				'&:last-child': {
					paddingRight: 0
				}
			}
		},
		showroomGridItemContent: {
			flexGrow: 1
		},
		showroomGridItemLabel: {
			overflow: 'hidden',
			height: 18,
			color: '#FFF'
		},
		showroomGridItemPortrait: {
			flex: '1 1 50%',
			[theme.breakpoints.up('sm')]: {
				flex: '1 1 auto'
			}
		},
		showroomGridItemLandscape: {
			flex: '3 1 auto'
		},
		previewMediaGridImg: {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
			cursor: (props: UserContentStylesProps) => (props.zoomEnabled ? 'pointer' : 'default'),
			WebkitUserSelect: 'none',
			MozUserSelect: 'none',
			userSelect: 'none',
			WebkitTouchCallout: 'none',
			WebkitTapHighlightColor: 'transparent'
		},
		showroomDialogAppBar: {
			position: 'relative'
		},
		dialogContent: {
			padding: 0
		},
		showroomDialogTitle: {
			paddingBottom: 0,
			marginLeft: 20,
			flex: 1
		},
		showroomDialogBackButton: {
			fontSize: 18
		},
		showroomDialogCloseButton: {
			'&:hover': {
				backgroundColor: 'rgba(255, 255, 255, 0.18)'
			},
			color: '#FFF'
		},
		dialogTitle: {
			position: 'absolute'
		},
		showroomDialogPrevButtonContainer: {
			zIndex: 10,
			position: 'absolute',
			left: 20,
			top: '50%',
			transform: 'translate(0, -50%)'
		},
		showroomDialogPrevButton: {
			'&:hover': {
				backgroundColor: 'rgba(255, 255, 255, 0.18)'
			},
			color: '#FFF'
		},
		showroomDialogNextButtonContainer: {
			zIndex: 10,
			position: 'absolute',
			right: 20,
			top: '50%',
			transform: 'translate(0, -50%)'
		},
		showroomDialogNextButton: {
			'&:hover': {
				backgroundColor: 'rgba(255, 255, 255, 0.18)'
			},
			color: '#FFF'
		},
		previewHeader: {
			background: 'transparent',
			boxShadow: 'none'
		},
		previewHeaderResponsive: {
			padding: '0 10px 0'
		},
		imageItemCard: {
			display: 'flex',
			position: 'relative'
		},
		imageItemCardContent: {
			position: 'absolute',
			bottom: 0,
			width: '100%',
			backgroundColor: 'rgb(255,255,255,0.1)'
		},
		imageItem: {
			backgroundColor: 'black',
			width: '100%',
			height: '100%',
			textAlign: 'center'
		},
		swipeableWrapper: {
			height: '100%',
			width: '100%',
			position: 'absolute',
			background: 'black'
		},
		swipeableSlide: {
			display: 'flex',
			height: '100%',
			width: '100%',
			justifyContent: 'center'
		},
		imageItemImg: {
			width: '100%',
			height: '100%',
			objectFit: 'contain'
		}
	};
});
